export enum StackDirection {
  Row = 'row',
  Column = 'column',
}

export default StackDirection;
